var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#FFF8E6",
    stroke: "#FCCA4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.439 23.439C28.3636 22.5212 29.0775 21.6091 29.544 20.955C29.848 20.5287 30 20.3155 30 20C30 19.6845 29.848 19.4713 29.544 19.045C28.1779 17.1294 24.6892 13 20 13C19.0922 13 18.2294 13.1548 17.4183 13.4183M14.7474 14.7474C12.7312 16.1072 11.2421 17.9427 10.456 19.045C10.152 19.4713 10 19.6845 10 20C10 20.3155 10.152 20.5287 10.456 20.955C11.8221 22.8706 15.3108 27 20 27C21.9908 27 23.7651 26.2557 25.2526 25.2526",
    stroke: "#FCCA4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8579 18C17.3278 18.53 17 19.2623 17 20.0711C17 21.6887 18.3113 23 19.9289 23C20.7377 23 21.47 22.6722 22 22.1421",
    stroke: "#FCCA4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11L29 29",
    stroke: "#FCCA4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.636d5f2473d05c32063d99b49dd5dffe.svg";
export { ForwardRef as ReactComponent };